/**
 * Fragment id of the host-program selector on `/anfitrion` ("¿No eres un
 * individuo?" — operators, companies, warehouses, brokers, 3PLs). Deep-linked
 * from surfaces that want to send a non-individual host straight past the
 * individual pitch, e.g. the home page's HostBand. One constant so the href
 * and the `id=` can never drift apart.
 */
export const HOST_PROGRAMS_ANCHOR = 'programas'
